export default __webpack_public_path__ + "static/media/light-inactive.1be4ee1c.png";